/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { donationModelSchema } from "./donationModelSchema.ts";
import { z } from "zod";

export const donationModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => donationModelSchema))
    })